import Tickets from '../../pages/Tickets';
import TicketView from '../../pages/Tickets/View';
import TicketReplies from '../../pages/Tickets/Replies';

import { uuid } from '../../utils/helper';

export default [
  {
    name: 'Tickets',
    link: '/tickets',
    component: Tickets,
    id: uuid(),
    exact: true,
    react: true,
  },
  {
    name: 'Tickets View',
    link: '/tickets/view',
    component: TicketView,
    id: uuid(),
    exact: true,
    react: true,
  },
  {
    name: 'Saved Replies',
    link: '/tickets/saved-replies',
    component: TicketReplies,
    id: uuid(),
    exact: true,
    react: true,
  },
];
